import { render, staticRenderFns } from "./ClientsAccounts.vue?vue&type=template&id=5a91c00c&scoped=true&"
import script from "./ClientsAccounts.vue?vue&type=script&lang=ts&"
export * from "./ClientsAccounts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91c00c",
  null
  
)

export default component.exports